import { MerchantPpPlusClaimMode } from "@redotech/cockroachdb-codegen/congodb/merchant-pp-plus-claim-mode";

interface MerchantClaimModeFields {
  merchantCreated?: boolean | null;
  merchantPpPlusClaimMode?: MerchantPpPlusClaimMode | null;
}

/**
 * A documented merchant PP+ claim walks the customer flow: every step and
 * required input applies, exactly as if the customer were filing.
 */
export function isDocumentedMerchantClaim(
  draftReturn: MerchantClaimModeFields,
): boolean {
  return (
    !!draftReturn.merchantCreated &&
    draftReturn.merchantPpPlusClaimMode === MerchantPpPlusClaimMode.Documented
  );
}

/**
 * Whether merchant flow shortcuts (skipped steps, optional inputs, merchant
 * item flow) apply. False for customers and for documented merchant claims.
 */
export function merchantFlowShortcutsEnabled(
  draftReturn: MerchantClaimModeFields,
): boolean {
  return (
    !!draftReturn.merchantCreated && !isDocumentedMerchantClaim(draftReturn)
  );
}
